export default __webpack_public_path__ + "static/media/layer06.64f039dc.png";